export default {
  "button/home": {
    en: "Home",
    fr: "Accueil",
  },
  "button/players": {
    en: "Players",
    fr: "Partenaires",
  },
  "button/create": {
    en: "Create a game",
    fr: "Initier une partie",
  },
  "button/confirm": {
    en: "Confirm",
    fr: "Confirmer",
  },
  "button/cancel": {
    en: "Cancel",
    fr: "Annuler",
  },
};
